import React from "react";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const AssetSettle = ({
  op,
  result,
  changeColor,
  fromComponent
}) => {
  changeColor("warning");

  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "proposal.asset_settle",
      keys: [{
        type: "account",
        value: op[1].account,
        arg: "account"
      }, {
        type: "amount",
        value: op[1].amount,
        arg: "amount"
      }]
    }));
  } else {
    const baseAmount = op[1].amount;
    const instantSettleCode = 2;

    if (result && result[0] == instantSettleCode) {
      const quoteAmount = result[1];
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
        string: "operation.asset_settle_instant",
        keys: [{
          type: "account",
          value: op[1].account,
          arg: "account"
        }, {
          type: "amount",
          value: baseAmount,
          arg: "amount"
        }, {
          type: "price",
          value: {
            base: baseAmount,
            quote: quoteAmount
          },
          arg: "price"
        }]
      }));
    } else {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
        string: "operation.asset_settle",
        keys: [{
          type: "account",
          value: op[1].account,
          arg: "account"
        }, {
          type: "amount",
          value: op[1].amount,
          arg: "amount"
        }]
      }));
    }
  }
};